// Shared display helpers.
// Bill / doc numbers are stored like `CSC/2026/0020` or `CSC/R/2026/0009`
// but must be shown everywhere as a 7-digit zero-padded number: `0000020`.
export const formatBill = (v) => {
  if (v === undefined || v === null || v === "") return "";
  const s = String(v);
  const parts = s.split("/");
  const last = parts[parts.length - 1] || s;
  const m = last.match(/\d+/);
  const n = m ? m[0] : last;
  return n.padStart(7, "0");
};
